import { useState } from 'react';
import { trackArticleFeedback } from '@/lib/utils/analytics';

/**
 * One-question "was this helpful?" micro-survey for /resources guides.
 * Guides had zero direct feedback signal before this — see TSF-129.
 */
export function ArticleFeedback({ articleSlug }: { articleSlug: string }) {
  const [given, setGiven] = useState(false);

  const handleClick = (helpful: boolean) => {
    trackArticleFeedback(articleSlug, helpful ? 'yes' : 'no');
    setGiven(true);
  };

  return (
    <div className="not-prose mt-10 rounded-lg border border-gray-200 bg-gray-50 p-4">
      {!given ? (
        <>
          <p className="text-sm font-medium text-gray-900">Was this guide helpful?</p>
          <div className="mt-2 flex gap-2">
            <button
              type="button"
              className="flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-4 py-2 text-sm text-gray-600 hover:border-primary hover:text-primary"
              onClick={() => handleClick(true)}
            >
              <span aria-hidden="true">👍</span> Yes
            </button>
            <button
              type="button"
              className="flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-4 py-2 text-sm text-gray-600 hover:border-primary hover:text-primary"
              onClick={() => handleClick(false)}
            >
              <span aria-hidden="true">👎</span> No
            </button>
          </div>
        </>
      ) : (
        <p className="text-sm text-gray-500">Thanks for the feedback!</p>
      )}
    </div>
  );
}
